export default "Fonds Vert 2026 — Transition Écologique des Collectivités | Solution Éco France";
